import { Outlet, useLocation } from 'react-router-dom';
import Header from '../FormsUI/Header/index';
import Footer from '../FormsUI/Footer/index';
import { useHeaderData } from '../../hooks/useHeaderData';
const HeaderLayout = () => {
  let url = window.location.host;
  const location = useLocation();
  const { data } = useHeaderData(url);
  const internetProfileData = data?.data?.body?.data?.body;
  if (internetProfileData?.name) {
    localStorage.setItem('tenantName', internetProfileData?.name);
  }
  document.title = internetProfileData?.name
    ? document.title + ' - ' + internetProfileData?.name
    : document.title;
  if (internetProfileData?.favicon) {
    const link = document?.querySelector("link[rel*='icon']") || document?.createElement('link');
    let extension = internetProfileData?.faviconFileName?.split('.');
    const mimetype = extension?.pop()?.toLowerCase();
    link.type = 'image/' + mimetype;
    link.rel = 'shortcut icon';
    link.href = internetProfileData?.favicon; // Put your base64 image data here
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  return (
    <>
      <Header
        logo={internetProfileData?.image}
        number={internetProfileData?.tollFreeNo}
        supportEmailId={internetProfileData?.supportEmail}
      />
      <Outlet />
      {(location.pathname.toLowerCase() === '/register' ||
        location.pathname.toLowerCase() === '/' ||
        location.pathname.toLowerCase() === '/digilocker') && (
        <Footer
          footer={internetProfileData?.footer}
          website={internetProfileData?.website}
          facebook={internetProfileData?.facebook}
          twitter={internetProfileData?.twitter}
        />
      )}
    </>
  );
};

export default HeaderLayout;
